export function isProd() {
    return ["bidra.spond.com", "fundraising.spond.com"].includes(
        window.location.hostname
    );
}

export function isUITest() {
    return window.location.hostname.includes("spond.qa");
}
